// extracted by mini-css-extract-plugin
module.exports = {"angle":"grant-about_angle__1ms51","aboutGrant":"grant-about_aboutGrant__3i3zZ","aboutGrantDescription":"grant-about_aboutGrantDescription__2L2-u"};